import React, { useState, useEffect } from "react";
import { colors, fonts } from "../utils/constants.js";
import { isMobile, getButtonStyle } from "../utils/responsive.js";

function GuestTips({ onClose, onSignUp }) {
  const [currentTip, setCurrentTip] = useState(0);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const checkIsMobile = () => setIsMobileDevice(isMobile());
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  useEffect(() => {
    // Auto-advance tips every 4 seconds
    const timer = setInterval(() => {
      setCurrentTip(prev => (prev + 1) % tips.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  const tips = [
    {
      icon: "🎯",
      title: "Прочетете внимателно",
      text: "Всеки въпрос има конкретна дата на решаване. Мислете дългосрочно!"
    },
    {
      icon: "📊",
      title: "Вижте тенденциите",
      text: "Процентите се променят в реално време с всеки нов глас."
    },
    {
      icon: "💭",
      title: "Вашето мнение има значение",
      text: "Всеки глас влияе на общественото мнение по важни въпроси."
    },
    {
      icon: "⚡",
      title: "Бързо и лесно",
      text: "Няма нужда от регистрация. Гласувайте веднага!"
    },
    {
      icon: "🏆",
      title: "Станете по-добри",
      text: "Проследявайте точността си с безплатен акаунт."
    }
  ];

  const tip = tips[currentTip];

  if (!isVisible) return null;

  return (
    <div
      className="bp-guest-tips"
      style={{
        position: "fixed",
        top: isMobileDevice ? 12 : 24,
        left: isMobileDevice ? 12 : 24,
        right: isMobileDevice ? 12 : "auto",
        background: colors.card,
        borderRadius: 8,
        padding: isMobileDevice ? 12 : 16,
        maxWidth: isMobileDevice ? "none" : 320,
        width: isMobileDevice ? "auto" : "320px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        border: `1px solid ${colors.border}`,
        zIndex: 999,
        animation: "slideInLeft 0.3s ease-out",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 18 }}>{tip.icon}</span>
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              textTransform: "uppercase",
              color: colors.green,
              letterSpacing: "0.5px",
            }}
          >
            Съвет #{currentTip + 1}
          </span>
        </div>
        <button
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            fontSize: 16,
            cursor: "pointer",
            color: colors.textTer,
            width: 20,
            height: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
          }}
          onMouseEnter={(e) => {
            e.target.style.background = colors.hover;
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
          }}
        >
          ×
        </button>
      </div>

      {/* Tip Content */}
      <div>
        <h4
          style={{
            margin: "0 0 6px 0",
            fontSize: 14,
            fontWeight: 600,
            color: colors.text,
          }}
        >
          {tip.title}
        </h4>
        <p
          style={{
            margin: 0,
            fontSize: 13,
            color: colors.textSec,
            lineHeight: 1.4,
          }}
        >
          {tip.text}
        </p>
      </div>

      {/* Progress dots */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 6,
          marginTop: 12,
          marginBottom: 12,
        }}
      >
        {tips.map((_, index) => (
          <div
            key={index}
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: index === currentTip ? colors.green : colors.border,
              transition: "background 0.3s",
            }}
          />
        ))}
      </div>

      {/* Action */}
      {currentTip === tips.length - 1 && (
        <button
          onClick={onSignUp}
          style={{
            ...getButtonStyle("primary", "small", isMobileDevice),
            width: "100%",
            background: colors.green,
            color: "#FFF",
            border: "none",
            fontSize: 12,
            padding: "8px 16px",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#059669";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = colors.green;
          }}
        >
          Регистрирай се безплатно
        </button>
      )}

      <style jsx>{`
        @keyframes slideInLeft {
          from {
            transform: translateX(-100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default GuestTips;